import React, { ReactElement } from 'react'
import styled from 'styled-components'

const SSpinner = styled.div<{ color?: string }>`
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;

    div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid ${({ theme }) => theme.brandColors.CA_Blue};
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${(props) => props.color} transparent transparent transparent;
    }

    div:nth-child(1) {
        animation-delay: -0.45s;
    }

    div:nth-child(2) {
        animation-delay: -0.3s;
    }

    div:nth-child(3) {
        animation-delay: -0.15s;
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`

const Spinner = ({ color }: { color?: string }): ReactElement => (
    <SSpinner color={color ?? '#006EF0'}>
        <div />
        <div />
        <div />
        <div />
    </SSpinner>
)

export default Spinner
